// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1UTqx{font-weight:500;min-height:450px}.modal__body{background:#f9fafb}@media (min-width:600px){.modal__content{padding:0 4rem 2rem}}@media (min-width:600px){.modal__content--floating{padding:0 2.4rem 2.4rem}}", ""]);
// Exports
exports.locals = {
	"modalViewContainer": "_1UTqx"
};
module.exports = exports;
